<app-toast></app-toast>
<app-calendly-pv-analyse-dialog></app-calendly-pv-analyse-dialog>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.services' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex flex-wrap gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'services.pv_roof' | transloco }}" [isActive]="true"
                    link="/services/pv-roof"></app-tab-button>
                <app-tab-button label="{{ 'shared.esg_reporting' | transloco }}"
                    link="/services/esg-reportings"></app-tab-button>
                <app-tab-button label="{{ 'shared.green_mobility' | transloco }}"
                    link="/services/green-mobility"></app-tab-button>
            </div>

            <p class="mt-10 font-bold text-3xl mobile:text-center">{{ 'services.select_business_location' | transloco}}
            </p>
            <div
                class="mt-4 w-full max-w-ultrawide rounded-[20px] border-[1px] border-border shadow-md flex flex-col justify-center items-center p-5 mobile:p-2 gap-2">
                <p class="font-bold text-xl self-start">{{ 'services.choose_location' | transloco}}</p>
                <div class="w-full">
                    <app-custom-dropdown [options]="locationsDropdownOptions"
                        [(selectedOption)]="selectedLocationDropdown"
                        (selectedOptionChange)="onDropdownOptionChange($event)" [disabled]="loadingData"
                        trailingIcon="assets/icons/location-primary.svg"></app-custom-dropdown>
                </div>
                <span class="loading loading-dots loading-lg" *ngIf="loadingData"></span>
            </div>

            <div class="mt-4 w-full max-w-ultrawide rounded-[20px] border-[1px] border-border shadow-md flex flex-col text-start p-5 mobile:p-2 gap-2"
                *ngIf="solarData !== null">
                <!--Header-->
                <div class="w-full flex desktop:flex-wrap mobile:flex-col gap-5 justify-between items-center">
                    <p class="font-bold text-xl">{{ 'services.solar_performance_analysis' | transloco}}</p>
                    <div class="w-[300px] h-[50px]">
                        <app-custom-button buttonText="{{ 'optimization.talk_to_specialist' | transloco }}"
                            backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                            hoverBackgroundColor="hover:bg-primary-1200" fontWeight="font-bold"
                            (buttonClick)="talkToSpecialist()"></app-custom-button>
                    </div>
                </div>

                <!--Top left and right-->
                <div class="w-full flex desktop:flex-wrap mobile:flex-col gap-5 items-center">
                    <div
                        class="desktop:flex-[1] mobile:w-full min-w-[300px] flex flex-col gap-2 justify-between h-auto">
                        <div class="w-full h-[300px] flex justify-center items-center" *ngIf="geoTiff !== null">
                            <div class="w-[300px] h-[300px]">
                                <app-geo-tiff-renderer [geoTiff]="geoTiff"
                                    *ngIf="geoTiff !== null"></app-geo-tiff-renderer>
                            </div>
                        </div>
                        <div class="w-full h-[300px] bg-border animate-pulse rounded-lg" *ngIf="geoTiff === null">
                        </div>

                        <div class="w-full flex desktop:flex-wrap mobile:flex-col gap-2">
                            <!--roof area-->
                            <div
                                class="flex flex-col desktop:flex-[1] max-h-[300px] mobile:w-full gap-5 items-center justify-evenly min-h-[200px] bg-primary-100 rounded-md p-4 min-w-[100px]">
                                <p class="text-neutral-800">{{'services.roof_area' | transloco}}</p>
                                <p class="font-bold">{{ roofArea !== null && roofArea !== undefined
                                    ? (roofArea | number:'1.2-2')
                                    : notAvailable }} m2</p>
                            </div>
                            <!--maximum number of panels-->
                            <div
                                class="flex flex-col desktop:flex-[1] max-h-[300px] mobile:w-full gap-5 items-center justify-evenly min-h-[200px] bg-primary-100 rounded-md p-4 min-w-[100px]">
                                <p class="text-neutral-800">{{'services.max_panels' | transloco}}</p>
                                <p class="font-bold">{{ maxPanels ?? notAvailable }}</p>
                            </div>
                            <!--roof area-->
                            <div
                                class="flex flex-col desktop:flex-[1] max-h-[300px] mobile:w-full gap-5 items-center justify-evenly min-h-[200px] bg-primary-100 rounded-md p-4 min-w-[100px]">
                                <p class="text-neutral-800">{{'services.roof_usage' | transloco}}</p>
                                <p class="font-bold">{{ roofUsage !== null && roofUsage !== undefined
                                    ? (roofUsage | number:'1.2-2')
                                    : notAvailable }}%</p>
                            </div>
                        </div>

                    </div>

                    <div
                        class="desktop:flex-[1] mobile:w-full min-w-[300px] flex flex-col justify-between gap-2 min-h-[500px] mobile:h-auto">
                        <!--annual sunshine-->
                        <div class="flex gap-2 items-center bg-primary-100 rounded-md p-4 flex-[1]">
                            <img src="assets/icons/services/sun-yellow.svg" class="w-[24px] h-[24px]"
                                alt="{{ 'shared.icon' | transloco }}">
                            <div class="w-full flex justify-between gap-1">
                                <p>{{'services.annual_sunshine' | transloco}}</p>
                                <p class="font-bold">{{ annualSunshine !== null && annualSunshine !== undefined
                                    ? (annualSunshine | number:'1.2-2')
                                    : notAvailable }} {{'services.hours_letter' | transloco}}</p>
                            </div>
                        </div>

                        <!--annual production-->
                        <div class="flex gap-2 items-center bg-primary-100 rounded-md p-4 flex-[1]">
                            <img src="assets/icons/services/power-yellow.svg" class="w-[24px] h-[24px]"
                                alt="{{ 'shared.icon' | transloco }}">
                            <div class="w-full flex justify-between gap-1">
                                <p>{{'services.annual_production' | transloco}}</p>
                                <p class="font-bold">{{ annualProduction !== null && annualProduction !== undefined
                                    ? (annualProduction | number:'1.2-2')
                                    : notAvailable }} kWh</p>
                            </div>
                        </div>

                        <!--pv capacity-->
                        <div class="flex gap-2 items-center bg-primary-100 rounded-md p-4 flex-[1]">
                            <img src="assets/icons/services/bulb-yellow.svg" class="w-[24px] h-[24px]"
                                alt="{{ 'shared.icon' | transloco }}">
                            <div class="w-full flex justify-between gap-1">
                                <p>{{'services.pv_capacity' | transloco}}</p>
                                <p class="font-bold">{{ pvCapacity !== null && pvCapacity !== undefined
                                    ? (pvCapacity | number:'1.2-2')
                                    : notAvailable }} kWp</p>
                            </div>
                        </div>

                        <!--yearly potential-->
                        <div class="flex flex-col w-full gap-5 bg-secondary-100 rounded-md p-4 text-secondary flex-[1]">
                            <p class="font-bold text-start text-xl">{{'services.yearly_saving_potential' | transloco}}
                            </p>
                            <p class="font-bold text-3xl text-center">€{{ yearlySavingPotential !== null &&
                                yearlySavingPotential !==
                                undefined
                                ? (yearlySavingPotential | number:'1.2-2')
                                : notAvailable }}</p>
                            <p class="text-center">{{ 'services.roi_timeframe' | transloco}}: {{ roiTimeFrame !== null
                                && roiTimeFrame !==
                                undefined
                                ? (roiTimeFrame | number:'1.2-2')
                                : notAvailable }} {{ 'services.years' | transloco}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!--Investment & ROI Analysis-->
            <div class="mt-4 w-full max-w-ultrawide rounded-[20px] border-[1px] border-border shadow-md flex flex-col text-start p-5 mobile:p-2 gap-2"
                *ngIf="solarData !== null">
                <!--Header-->
                <div class="flex gap-2">
                    <img src="assets/icons/services/calculator-secondary.svg" class="w-[24px] h-[24px]"
                        alt="{{ 'shared.icon' | transloco }}">
                    <p class="font-bold text-xl">{{ 'services.investment_roi' | transloco}}</p>
                </div>

                <!--Left and right-->
                <div class="w-full flex desktop:flex-wrap mobile:flex-col gap-5 items-center">
                    <div
                        class="desktop:flex-[1] mobile:w-full min-w-[300px] flex flex-col gap-2 justify-between h-auto">
                        <div class="w-full mobile:h-[300px] h-[400px]">
                            <app-return-on-investment-chart [initialInvestment]="initialInvestment"
                                [yearlyReturn]="yearlyReturn"
                                [roiTimeFrame]="panelLifetimeYears"></app-return-on-investment-chart>
                        </div>
                    </div>
                    <div
                        class="desktop:flex-[1] mobile:w-full min-w-[300px] flex flex-col gap-5 justify-between h-auto">
                        <p class="text-xl font-bold">{{ 'services.roi_summary_title' | transloco}}</p>
                        <!--Initial investment-->
                        <div class="flex w-full gap-2 flex-wrap justify-between items-center">
                            <p class="text-neutral-800">{{'services.initial_investment_label' | transloco}}</p>
                            <p class="font-bold text-lg">€{{ initialInvestment !== null && initialInvestment !==
                                undefined
                                ? (initialInvestment | number:'1.2-2')
                                : notAvailable }}</p>
                        </div>

                        <!--Yearly return-->
                        <div class="flex w-full gap-2 flex-wrap justify-between items-center">
                            <p class="text-neutral-800">{{'services.yearly_return_label' | transloco}}</p>
                            <p class="font-bold text-lg">€{{ yearlyReturn !== null && yearlyReturn !== undefined
                                ? (yearlyReturn | number:'1.2-2')
                                : notAvailable }}</p>
                        </div>

                        <!--Break even timeline-->
                        <div class="flex w-full gap-2 flex-wrap justify-between items-center">
                            <p class="text-neutral-800">{{'services.break_even_timeline_label' | transloco}}</p>
                            <p class="font-bold text-lg">{{ breakEventTime !== null && breakEventTime !== undefined
                                ? (breakEventTime | number:'1.2-2')
                                : notAvailable }} {{'services.years' | transloco}}</p>
                        </div>

                        <!--25 year return-->
                        <div class="flex w-full gap-2 flex-wrap justify-between items-center">
                            <p class="text-neutral-800">{{'services.return_25_year_label' | transloco: {value:
                                panelLifetimeYears} }}</p>
                            <p class="font-bold text-lg">€{{ manyYearsReturn !== null && manyYearsReturn !== undefined
                                ? (manyYearsReturn | number:'1.2-2')
                                : notAvailable }}</p>
                        </div>

                        <div class="flex w-full gap-2 flex-wrap justify-between items-center">
                            <p class="text-neutral-800">{{'services.co2_reduction_label' | transloco}}</p>
                            <p class="font-bold text-lg">
                                {{'services.co2_reduction_value' | transloco: {value: (coReduction !== null &&
                                coReduction !== undefined
                                ? (coReduction | number:'1.2-2')
                                : notAvailable)} }}

                        </div>

                        <div class="flex w-full gap-2 p-2 bg-primary-100 rounded-md items-center">
                            <img src="assets/icons/services/tree.svg" class="w-[24px] h-[24px]"
                                alt="{{ 'shared.icon' | transloco }}">
                            <p class="text-base">{{'services.co2_equivalent_value' | transloco: { value:
                                (equalTrees !== null &&
                                equalTrees !== undefined
                                ? (equalTrees | number:'1.0-2')
                                : notAvailable) } }}</p>
                        </div>

                        <div class="w-full h-[50px]">
                            <app-custom-button buttonText="{{ 'optimization.talk_to_specialist' | transloco }}"
                                backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                                hoverBackgroundColor="hover:bg-primary-1200" fontWeight="font-bold"
                                (buttonClick)="talkToSpecialist()"></app-custom-button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Book a Free Consultation-->
            <div class="mt-4 w-full max-w-ultrawide rounded-[20px] border-[1px] border-border shadow-md flex flex-col text-start p-5 mobile:p-2 gap-2"
                *ngIf="solarData !== null">
                <!--Header-->
                <div class="flex gap-2">
                    <img src="assets/icons/calendar-primary.svg" class="w-[24px] h-[24px]"
                        alt="{{ 'shared.icon' | transloco }}">
                    <p class="font-bold text-xl">{{ 'services.book_consultation_title' | transloco}}</p>
                </div>

                <div class="w-full flex desktop:flex-wrap mobile:flex-col gap-5 items-center">
                    <div
                        class="desktop:flex-[1] mobile:w-full min-w-[300px] flex flex-col gap-5 justify-between h-auto text-neutral-800">
                        <p>{{ 'services.book_consultation_description' | transloco}}</p>

                        <div class="flex gap-2 items-center">
                            <img src="assets/icons/services/check-primary.svg" class="w-[24px] h-[24px]"
                                alt="{{ 'shared.icon' | transloco }}">
                            <p>{{ 'services.book_consultation_bullet_1' | transloco}}</p>
                        </div>
                        <div class="flex gap-2 items-center">
                            <img src="assets/icons/services/check-primary.svg" class="w-[24px] h-[24px]"
                                alt="{{ 'shared.icon' | transloco }}">
                            <p>{{ 'services.book_consultation_bullet_2' | transloco}}</p>
                        </div>
                        <div class="flex gap-2 items-center">
                            <img src="assets/icons/services/check-primary.svg" class="w-[24px] h-[24px]"
                                alt="{{ 'shared.icon' | transloco }}">
                            <p>{{ 'services.book_consultation_bullet_3' | transloco}}</p>
                        </div>
                        <div class="w-full h-[50px]">
                            <app-custom-button buttonText="{{ 'services.book_consultation_cta' | transloco }}"
                                backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                                hoverBackgroundColor="hover:bg-primary-1200" fontWeight="font-bold"
                                (buttonClick)="talkToSpecialist()"></app-custom-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>